import Cookies from 'js-cookie';
import { util } from '@/lib/utils';
import config from '@/config';
import { browser } from '@/lib/ua';
import { updateLoginInfo } from '../comm/utils';

export function getUserInfo() {
  // 增加app中逻辑，app中不管localstorege的情况
  if (Cookies.get('MT_USER_INFO') !== undefined) {
    return {};
  }
  // 用户微信联合登录判断
  let userInfo = Cookies.get('userInfo') ? JSON.parse(Cookies.get('userInfo')) : null;
  if (!userInfo) {
    // 用户网页登录判断
    const mtCode = Number(Cookies.get('mtcode') || -1);
    if (mtCode !== -1) {
      userInfo = {
        encUserId: Cookies.get('mtencUserId'),
        isHaveMobile: Cookies.get('mtisHaveMobile'),
        name: Cookies.get('mtname'),
        token: Cookies.get('mttoken')
      };
    }
  }
  if (!userInfo && window.localStorage && !browser.wx) {
    const userInfoStr = window.localStorage.getItem('userinfo');
    userInfo = userInfoStr ? JSON.parse(userInfoStr) : null;
  }
  if (userInfo) {
    Cookies.set('userInfo', userInfo);
    updateLoginInfo({ token: userInfo.token, userInfo });
  }
  return userInfo;
  // app 中的按照老逻辑，未做init
}

const auth = {
  // 检查
  check(type) {
    // 专家登录判断
    if (type === 'expert') {
      const expertInfo = Cookies.get('expertInfo') ? JSON.parse(Cookies.get('expertInfo')) : null;
      return expertInfo && expertInfo.token !== null;
    }

    // 用户微信联合登录判断
    const userInfo = Cookies.get('userInfo') ? JSON.parse(Cookies.get('userInfo')) : null;
    if (userInfo) {
      const userSource = userInfo.userSource;
      const weixinUserInfo = userInfo.weixinUserInfo ? userInfo.weixinUserInfo : null;
      if (userSource === 0) {
        if (weixinUserInfo) {
          return true;
        }
        return false;
      }
      return userInfo.token !== null;
    }

    // 用户网页登录判断
    const mtCode = Number(Cookies.get('mtcode') || -1);
    let mtTokenStr = Cookies.get('mttoken') ? Cookies.get('mttoken') : null;
    let appEncUserId = null;
    if (!mtTokenStr && Cookies.get('MT_USER_INFO')) {
      const fck = Cookies.get('MT_USER_INFO').split(',');
      mtTokenStr = util.base64Decode(fck[3]);
      appEncUserId = util.base64Decode(fck[5]);
    }
    return !Cookies.get('MT_USER_INFO') ? (mtTokenStr && mtCode === 0) : !!mtTokenStr && !!appEncUserId;
  },

  // 登录
  login(type, code, next, isMsgList) {
    if (type === 'expert' && !code) {
      // 授权之后会带上 access_token
      if (isMsgList) {
        location.href = `${config.babytreeAjaxPrefix}/app/dayima/expert/user/login?source=msglist`;
        return;
      }
      location.href = `${config.babytreeAjaxPrefix}/app/dayima/expert/user/login?source=meitun`;
    } else if (type === 'user' && Cookies.get('MT_USER_INFO')) {
      location.href = '//m.meitun.com/live/?mtoapp=5';
    } else if (type === 'user' && !code && browser.wx) {
      // 授权之后会带上 code
      location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx5699bb5297ae3984&redirect_uri=${encodeURIComponent(document.URL)}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    } else if (type === 'dayima' && !code && browser.wx) {
      location.href = `${config.babytreeAjaxPrefix}/app/dayima/expert/user/login?source=mtverify`;
    } else if (type === 'user' && !browser.wx) {
      /**
       * @auth houquan
       * @dete 2018-11-14
       * 由于北京孕育对 redirect_url 做了两次 decode 导致 unionLogin 拿到的参数丢失，而且北京团队进行修改需要的评估影响面需要的时间较长，暂时对 redirect_url 进行两次 encode 进行 hack 修复
       * 保险起见，建议后端对 redirct_url 进行两次 decode，对应的后端开发 @李琦
       */
      location.href = `${config.babytreeLoginPrefix}/reg/signin.php?url=${encodeURIComponent(`${location.protocol}//m.meitun.com/mobile/system/bbtUnionLogin.htm?redirect_url=${encodeURIComponent(encodeURIComponent(document.URL))}`)}`;
    } else if (next) {
      next();
    } else {
      location.href = '//m.meitun.com/live/';
    }
  },

  // 退出登录
  clear() {
    Cookies.set('userInfo', '', { expires: -1 });
    Cookies.set('expertInfo', '', { expires: -1 });
    if (window.localStorage) {
      window.localStorage.removeItem('userinfo');
      window.localStorage.removeItem('token');
    }
  },

  // 获取登录信息
  get() {
    let userInfo = Cookies.get('userInfo') ? JSON.parse(Cookies.get('userInfo')) : null;
    // // 如果在APP中 防止不同用户登录记录在app中与H5网页中的 登录信息不一致，导致获取信息错误 当两边登录信息不一致时，强制将APP中的用户信息赋给H5中存储的用户信息
    const mtTokenStr = userInfo ? userInfo.token : null;
    const mtEncUserIdStr = userInfo ? userInfo.encUserId : null;
    const allCookies = Cookies.get();
    const mtcookit = allCookies.MT_USER_INFO;
    if (mtTokenStr && mtcookit) {
      const fck = mtcookit.split(',');
      const appTokenStr = util.base64Decode(fck[3]);
      const appEncUserId = util.base64Decode(fck[5]);
      if (mtTokenStr !== appTokenStr || mtEncUserIdStr !== appEncUserId) {
        userInfo = {
          token: appTokenStr,
          encUserId: appEncUserId,
          avatar: null,
          nickName: '宝宝树用户',
          isHaveMobile: util.base64Decode(fck[4]) ? 1 : 0
        };
      }
    }
    return userInfo;
  }
};

export default auth;



// WEBPACK FOOTER //
// ./src/lib/auth.js